import * as firebase from 'firebase/app';
import Category from './category-model';
import UIkit from 'uikit';

class ProductModel {
    constructor(table) {
        this.ref = firebase.database().ref(table);
        this.productKey = this.ref.push().key;
        this.save = firebase.database().ref(table + '/' + this.productKey);
    }
    
    getProduct(callback) {
        this.ref.on('value', snapshot => {
            //var key = Object.keys(snapshot.val());
            snapshot.forEach(item => {
                callback(item.val());
            });
        });
    }
    
    getProductCategory(callback) {
        var category = new Category('category');
        category.ref.on('value', snapshot => {
            snapshot.forEach(item => {
                callback(item.val());
            });
        });
    }
    
    saveProduct(data) {
        this.save.set(data, error => {
            if (error) {
                alert(error);
            } else {
                UIkit.notification('<span uk-icon="icon: check"></span>&nbsp;Produk berhasil dipajang.', {
                    status: 'success',
                    timeout: 2000
                });
                //alert("Produk berhasil dipajang.");
            }
        });
    }
}

export default ProductModel;